import { styled } from "@mui/material";

export const MainStyles = styled("main")`
  flex: 1 1 100%;
  display: flex;
  overflow: hidden;
  justify-content: stretch;

  .leaflet-container {
    flex: 1 1 100%;
  }
`;
